module.exports = __webpack_public_path__ + "img/ico1_active.99a06a68.png";